import { CHANNEL_TAG_GROUPS } from 'tradera-state/push-notifications/constants';
import GdprSettings from 'tradera-utils/gdpr-settings';
import logger from 'packages/logger';

/**
 * get the urban airship sdk.
 * @returns obj if null then no sdk object available
 */
export const getUrbanSdk = () => {
    return new Promise(resolve => {
        // script from urban airship not loaded
        if (!window.UA) {
            return resolve(null);
        }

        // is already loaded?
        if (window.UACache) {
            return resolve(window.UACache);
        }

        UA.then(async sdk => {
            if (sdk !== null && !sdk.isSupported) {
                sdk = null;
            }
            window.UACache = sdk;
            return resolve(window.UACache);
        }).catch(() => {
            // browser is most likely not supported, return null
            window.UACache = null;
            return resolve(null);
        });
    });
};

export const getTagGroupsFromUrbanAirship = async () => {
    try {
        const sdk = await getUrbanSdk();
        if (sdk.channel === null) {
            return null;
        }

        // check what tag groups are active
        let tagGroups = {};
        for (const [group, groupTags] of Object.entries(CHANNEL_TAG_GROUPS)) {
            for (const tag of groupTags) {
                tagGroups[group] = sdk.channel.tags.has(tag) === true;
                if (tagGroups[group] === true) {
                    break;
                }
            }
        }
        return tagGroups;
    } catch (error) {
        logger(error);
    }
};

export const isPushEnabled = getState => {
    const {
        member,
        initData: { featureSwitches }
    } = getState();

    // something blocking notifications modal from being shown?
    if (
        !GdprSettings.isFunctionalEnabled() ||
        !member.isLoggedIn ||
        featureSwitches['web-push-notifications'] !== true
    ) {
        return false;
    }
    return true;
};
